<template>
    <Transition>
        <div v-if="isTruthsTime" id="background">
            <Transition name='wordFade'>
            <div v-if="firstScreen" ref="wordContainer" class="wordContainer">
                <h2>These things are true</h2>
                <p v-if="secondScreen && candles > 0" >The World is Dark</p>
                <p id="numbers" v-if="!secondScreen">{{ index }}</p>
                <p v-if="!secondScreen">Establish more truths</p>

            </div>
            </Transition>
            
            <Transition name='lastScreen'>
                <div v-if="lastScreen"  class="wordContainer">
                    <h2>{{candles > 0 ? "And We Are Alive" : "The World is Dark"}}</h2>
                    <p v-if="!lastMessage" :class="{ isHidden: lastScreen }"></p>
                    <Transition name='wordFade'>
                        <p v-if="lastMessage" :style="{color: 'rgba(255,255,255,0.3)'}">Play the final message</p>
                    </Transition>
                </div>
            </Transition>

            
        </div>
    </Transition>
</template>

<script>
import { storeToRefs } from 'pinia';
import {useCandleStore} from '../store/useCandleStore'

export default {
    name:"EstablishTruths",
    setup(){
        const candleStore = useCandleStore();
        const {candles, isTruthsTime, isLastStand} = storeToRefs(candleStore)
        return {
            candles,
            isTruthsTime,
            isLastStand
        }
    },
    mounted(){
        window.addEventListener('keypress', (e =>{
            if(e.code === "Space" && this.isTruthsTime)
                this.next();
        }))

    },
    data(){
        return {
            index: this.candles-2,
            secondScreen: true,
            lastScreen: false,
            firstScreen: true,
            lastMessage:false
        }
    },
    methods:{
        next(){

            if(this.firstScreen && this.candles <= 1){ // when the last candle is out
                this.firstScreen = false;
                setTimeout(()=> this.lastScreen = true, 1200)
                setTimeout(()=> this.lastMessage = true, 5000)

            }
            if(this.secondScreen) return this.secondScreen = false; // move from openning phrase to truths countdown
            else if(this.index > 1) this.index--; // truths countdown
            else if(this.firstScreen){ // move from truthscountdown to we're alive
                this.firstScreen = false;
                setTimeout(()=> this.lastScreen = true, 1200)
            }
            else if(this.candles === 1 && this.isLastStand === false) this.isLastStand = true; // trigger "last stand" during "we're alive" message

            else this.clearStage(); // clears the screen
        },
        clearStage(){
                this.isTruthsTime = false
                
                setTimeout(() => {
                this.secondScreen = true
                this.index = this.candles-2
                this.lastScreen = false;
                this.firstScreen = true;

                }, 3000)


        }


    }

}
</script>

<style scoped>

#background {
    width: 100%;
    height: 100%;
    position:absolute;
    background-color: rgba(7, 7, 14, 0.973);
    margin: -55px;
    z-index:2;
    
}

.wordContainer {
      width: 100%;
    height: 100%;
    z-index:2;
    color:white;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 35px;
    font-size: 2.75em;
}

#numbers {
    font-size: 3.25em;
}

.isHidden {
    opacity: 0;
}

.v-enter-active,.v-leave-active {
    transition: opacity 2s ease;
}

.v-enter-from, .v-leave-to {
    opacity: 0;
}

 .wordFade-leave-active {
    transition: opacity 1s ease;
}

.wordFade-enter-active {
    transition: opacity 2s ease
}

.wordFade-enter-from, .wordFade-leave-to {
    opacity: 0;
}

 .lastScreen-leave-active {
    transition: opacity 1s ease;
}

.lastScreen-enter-active {
    transition: opacity 2s ease
}

.lastScreen-enter-from, .lastScreen-leave-to {
    opacity: 0;
}

</style>